// Calendar data
const _daysInMonths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const _weekdayLabels = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
const _weekdayLength = 3;
const _weekdayCasing = 'title';
const _monthLabels = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];
const _monthLength = 0;
const _monthCasing = 'title';

// Helper function for label transformation
const _transformLabel = (label, length, casing) => {
  label = length <= 0 ? label : label.substring(0, length);
  if (casing.toLowerCase() === 'lower') return label.toLowerCase();
  if (casing.toLowerCase() === 'upper') return label.toUpperCase();
  return label;
};

// Today's data
const _today = new Date();
const _todayComps = {
  year: _today.getFullYear(),
  month: _today.getMonth() + 1,
  day: _today.getDate(),
  week: Math.floor(_today.getDate() / 7) + 1,
};

function weekCount(year, month_number) {
  const firstOfMonth = new Date(year, month_number - 1, 1);
  const lastOfMonth = new Date(year, month_number, 0);
  const used = firstOfMonth.getDay() + lastOfMonth.getDate();
  return Math.ceil(used / 7);
}

function getSunday(d) {
  d = new Date(d);
  const day = d.getDay();
  const diff = d.getDate() - day + (day == 0 ? -6 : 0); // adjust when day is sunday
  return new Date(d.setDate(diff));
}

function getSaturday(d) {
  d = new Date(d);
  const day = d.getDay();
  const diff = d.getDate() - day + (day == 0 ? -6 : 0) + 6; // adjust when day is sunday
  return new Date(d.setDate(diff));
}

new Vue({
  el: '#app',
  data: {
    startingMonth: _todayComps.month,
    startingYear: _todayComps.year,
    view: 'list',
    month: _todayComps.month,
    year: _todayComps.year,
    viewingWeek: _todayComps.week,
    eventsFetched: [],
    eventList: [],
    activeEvent: '',
    selectedDay: '',
    selectedMonth: '',
    selectedDayEvents: [],
    categoryFilter: ['cultura', 'infantil', 'esporte', 'moda', 'gastronomia', 'musica', 'diversos'],
  },
  computed: {
    getLumisRoot_href() {
      return window.g_LumisRoot_href;
    },
    isFirstMonth() {
      return this.month === this.startingMonth && this.year === this.startingYear;
    },
    // Our component exposes month as 1-based, but sometimes we need 0-based
    monthIndex() {
      return this.month - 1;
    },
    // State referenced by header (no dependencies yet...)
    months() {
      return _monthLabels.map((ml, i) => ({
        label: ml,
        label_1: ml.substring(0, 1),
        label_2: ml.substring(0, 2),
        label_3: ml.substring(0, 3),
        number: i + 1,
      }));
    },
    // State for weekday header (no dependencies yet...)
    weekdays() {
      return _weekdayLabels.map((wl, i) => ({
        label: wl,
        label_1: wl.substring(0, 1),
        label_2: wl.substring(0, 2),
        label_3: wl.substring(0, 3),
        number: i + 1,
      }));
    },
    // State for calendar header
    header() {
      const month = this.months[this.monthIndex];
      return {
        month,
        year: this.year.toString(),
        shortYear: this.year.toString().substring(2, 4),
        label: month.label,
      };
    },
    // Returns number for first weekday (1-7), starting from Sunday
    firstWeekdayInMonth() {
      return new Date(this.year, this.monthIndex, 1).getDay() + 1;
    },
    // Returns number of days in the current month
    daysInMonth() {
      // Check for February in a leap year
      if (this.month === 2 && this.isLeapYear) return 29;
      // ...Just a normal month
      return _daysInMonths[this.monthIndex];
    },
    weeks() {
      const weeks = [];
      let previousMonth = true,
        thisMonth = false,
        nextMonth = false;
      let day = this.previousMonthComps.days - this.firstWeekdayInMonth + 2;
      let month = this.previousMonthComps.month;
      let year = this.previousMonthComps.year;

      // Cycle through each week of the month, up to 6 total
      for (let w = 1; w <= 6 && !nextMonth; w++) {
        // Cycle through each weekday
        const week = [];
        for (let d = 1; d <= 7; d++) {
          // We need to know when to start counting actual month days
          if (previousMonth && d >= this.firstWeekdayInMonth) {
            // Reset day/month/year counters
            day = 1;
            month = this.month;
            year = this.year;
            // ...and flag we're tracking actual month days
            previousMonth = false;
            thisMonth = true;
          }

          // Append day info for the current week
          // Note: this might or might not be an actual month day
          //  We don't know how the UI wants to display various days,
          //  so we'll supply all the data we can
          week.push({
            label: day.toString(),
            day,
            weekday: d,
            week: w,
            month,
            year,
            date: new Date(year, month - 1, day),
            beforeMonth: previousMonth,
            afterMonth: nextMonth,
            inMonth: thisMonth,
            isToday:
              day === _todayComps.day && month === _todayComps.month && year === _todayComps.year,
            isInvalid:
              (day < _todayComps.day && month === _todayComps.month && year === _todayComps.year) ||
              (month < _todayComps.month && year === _todayComps.year) ||
              year < _todayComps.year,
            isFirstDay: thisMonth && day === 1,
            isLastDay: thisMonth && day === this.daysInMonth,
            events: this.getEventsOfTheDay(this.filteredEvents, year, month, day),
          });

          // We've hit the last day of the month
          if (thisMonth && day >= this.daysInMonth) {
            thisMonth = false;
            nextMonth = true;
            day = 1;
            month = this.nextMonthComps.month;
            year = this.nextMonthComps.year;
            // Still in the middle of the month (hasn't ended yet)
          } else {
            day++;
          }
        }
        // Append week info for the month
        weeks.push(week);
      }
      return weeks;
    },
    isLeapYear() {
      return (this.year % 4 === 0 && this.year % 100 !== 0) || this.year % 400 === 0;
    },
    // Data components for previous month
    previousMonthComps() {
      if (this.month === 1)
        return {
          days: _daysInMonths[11],
          month: 12,
          year: this.year - 1,
        };
      return {
        days: this.month === 3 && this.isLeapYear ? 29 : _daysInMonths[this.monthIndex - 1],
        month: this.month - 1,
        year: this.year,
      };
    },
    // Data components for next month
    nextMonthComps() {
      if (this.month === 12)
        return {
          days: _daysInMonths[0],
          month: 1,
          year: this.year + 1,
        };
      return {
        days: this.month === 1 && this.isLeapYear ? 29 : _daysInMonths[this.monthIndex + 1],
        month: this.month + 1,
        year: this.year,
      };
    },
    weekstart() {
      const weekStartDate = getSunday(
        new Date(this.year, this.month - 1, this.viewingWeek * 7 - (this.firstWeekdayInMonth - 1)),
      );
      return `${weekStartDate.getDate()}/${weekStartDate.getMonth() + 1}`;
    },
    weekend() {
      const weekStartDate = getSaturday(
        new Date(this.year, this.month - 1, this.viewingWeek * 7 - (this.firstWeekdayInMonth - 1)),
      );
      return `${weekStartDate.getDate()}/${weekStartDate.getMonth() + 1}`;
    },
    filteredEvents() {
      let filtered = this.eventList;
      const self = this;

      filtered = filtered.filter(item => self.categoryFilter.indexOf(item.categoria) > -1);
      return filtered;
    },
    filteredMonthEvents() {
      const filtered = this.filteredEvents;
      const self = this;

      return filtered.filter(item => {
        for (const i in item.datas) {
          if (item.datas[i].month == self.month && item.datas[i].year == self.year) {
            return true;
          }
        }

        return false;
      });
    },
    // End of computed properties
  },
  methods: {
    moveThisMonth() {
      this.month = _todayComps.month;
      this.year = _todayComps.year;
    },
    moveNextMonth() {
      const { month, year } = this.nextMonthComps;
      this.month = month;
      this.year = year;
      this.viewingWeek = 1;
    },
    movePreviousMonth(e) {
      const { month, year } = this.previousMonthComps;
      this.month = month;
      this.year = year;
      this.viewingWeek = 1;

      if (this.isFirstMonth) {
        $(e.target).blur();
      }
    },
    moveNextWeek(e) {
      this.viewingWeek++;
      if (this.viewingWeek > weekCount(this.year, this.month)) {
        this.moveNextMonth();
        const skip = this.firstWeekdayInMonth == 1 ? 0 : 1;
        this.viewingWeek = 1 + skip;
      }
    },
    movePreviousWeek() {
      this.viewingWeek--;
      const skip = this.firstWeekdayInMonth == 1 ? 0 : 1;
      if (this.viewingWeek < 1) {
        this.movePreviousMonth();
        this.viewingWeek = weekCount(this.year, this.month) - skip;
      }
    },
    moveNextYear() {
      this.year++;
    },
    movePreviousYear() {
      this.year--;
    },
    changeView() {
      this.view == 'weekly' ? (this.view = 'monthly') : (this.view = 'weekly');
    },
    getCalendarData() {
      // const RESTurl = g_LumisRoot_href + g_LumisLocale.toLocaleLowerCase() + '/shopping/agenda/eventos.json'
      const RESTurl = '/js/eventos.json';

      const self = this;
      const jqxhr = $.getJSON(RESTurl, () => {})
        .done(data => {
          const temp = data.rows;
          for (var i = 0; i < temp.length; i++) {
            const found = self.eventList.some(el => el.id === temp[i].id);
            if (!found) {
              self.eventList.push(temp[i]);
            }
          }
        })
        .fail(err => {});
    },
    selectEvents(events, day, month) {
      const self = this;
      this.selectedDay = day;
      this.selectedMonth = month + '';
      if (this.selectedMonth.length == 1) {
        this.selectedMonth = '0' + this.selectedMonth;
      }
      for (let i = 0; i < events.length; i++) {
        self.selectedDayEvents.push(events[i]);
      }
    },
    clearEventsOnEsc() {
      if (event.which === 27) {
        this.selectedDayEvents = [];
      }
    },
    clearEvents() {
      this.selectedDayEvents = [];
    },
    getEventsOfTheDay(events, year, month, day) {
      const eventsOnThisDay = [];
      events.forEach(event => {
        for (let i = 0; i < event.datas.length; i++) {
          const startingDate = new Date(
            event.datas[i].year,
            event.datas[i].month - 1,
            event.datas[i].dayOfMonth,
          ).getTime();
          const actualDate = new Date(year, month - 1, day).getTime();
          if (startingDate == actualDate) {
            eventsOnThisDay.push(event);
          }
        }
      });

      return eventsOnThisDay.sort((a, b) => {
        if (a.ordem === b.ordem) {
          return a.nome < b.nome ? -1 : 1;
        }

        return a.ordem < b.ordem ? -1 : 1;
      });
    },
    hasHighlightedEvents(events) {
      for (let i = 0; i < events.length; i++) {
        if (events[i].exibirHome == 'true') {
          return true;
        }
      }
      return false;
    },
    hasFutureDate(event) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      for (let i = 0; i < event.datas.length; i++) {
        const date = new Date(
          event.datas[i].year,
          event.datas[i].month - 1,
          event.datas[i].dayOfMonth,
        );
        date.setHours(0, 0, 0, 0);

        if (date > today) {
          return true;
        }
      }

      return false;
    },
    htmlDecode(input) {
      const e = document.createElement('div');
      e.innerHTML = input;
      return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
    },
    eventFilter() {},
  },
  created() {
    this.getCalendarData();
  },
  beforeMount() {
    window.addEventListener('keyup', this.clearEventsOnEsc);
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.clearEventsOnEsc);
  },
});
